import { HttpErrorResponse } from '@angular/common/http';

export function getError(exception: HttpErrorResponse): string {
  return exception.error?.exceptionMessage ? exception.error.exceptionMessage : "Unexpected error: Please contact administrator.";
}
